module.exports = __webpack_public_path__ + "src/assets/img/road2.269b343f.svg";